import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { DarkModeService } from '../../../services/dark-mode.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { StorageService } from '../../../services/storage.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { Observable } from 'rxjs';
import { LanguageTranslation } from '../../../store/entities/system-configurations/language-translation/language-translation.model';
import { TranslateService } from '@ngx-translate/core';
import { selectStoreItems } from '../../../store/entities/store-item/store-item.selectors';
import { StoreItemEntity } from '../../../store/entities/store-item/store-item.model';
import { systemName } from '../../../store/base.entity';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenu } from '@angular/material/menu';
import { SharedModule } from '../../../shared/shared.module';
import { HamburgerButtonComponent } from "../../../shared/components/hamburger-button/hamburger-button.component";

@Component({
  selector: 'app-guest-top-bar',
  templateUrl: './guest-top-bar.component.html',
  styleUrl: './guest-top-bar.component.scss',
  standalone: true,
  imports: [
    RouterLink,
    MatIconModule,
    MatListModule,
    MatMenu,
    SharedModule,
    HamburgerButtonComponent
  ],
})
export class GuestTopBarComponent implements OnInit {
  authService = inject(AuthService);
  darkModeService: DarkModeService = inject(DarkModeService);
  private router: Router = inject(Router);
  private storageService: StorageService = inject(StorageService);
  store: Store<AppState> = inject(Store<AppState>);

  languages$: Observable<LanguageTranslation[]>;
  @Input() currentState: 'openState' | 'closeState' = 'closeState';
  @Input() isDrawable: boolean = false;
  @Output() drawerToggle = new EventEmitter<any>();
  activeLang: string = 'English';
  activeLightMode: 'light' | 'night' = 'light';
  authUser: any;

  isLightMode: boolean;

  private translate: TranslateService = inject(TranslateService);

  ngOnInit() {
    this.activeLightMode = this.darkModeService.isDarkMode ? 'night' : 'light';
    this.isLightMode = this.activeLightMode === 'light';
    // this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
    //   query: GET_ALL_LANGUAGE,
    //   entity: StoreItemEntity.activeLanguage,
    //   filtering: {}
    // }))
    this.languages$ = this.store.select(
      selectStoreItems(StoreItemEntity.activeLanguage)
    );
  }

  toggleTheme() {
    this.activeLightMode = this.isLightMode ? 'light' : 'night';
    this.darkModeService.toggleDarkMode();
  }

  toggleState() {
    this.drawerToggle.emit();
  }

  joinMeeting() {
    this.router.navigate(['auth/join-meeting']);
  }

  scheduleMeeting() {
    this.router.navigate(['auth'],  {
      queryParams: { next: 'instant'},
    });
  }

  changeLanguage(language: 'sw' | 'en'): void {
    this.translate.use(language);
    localStorage.setItem('lang', language);
  }

  protected readonly systemName = systemName;
  
scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
}
